import { useCurrentRole } from './useCurrentRole';
import { useIsAdminImpersonating } from './useCurrentUser';

// Faks status is scoped to the current role, not the totality of the user's roles: an admin acting on
// their lab is a lab user, not an admin, in that context. The faks kinds are unique to the Faks org
// role (resource roles use lab_admin, group_admin, …), so the current role's kind is enough.
export const useIsCurrentUserAdmin = () => {
  const kind = useCurrentRole()?.kind;
  return kind === 'admin' || kind === 'super_admin';
};
export const useIsUserOnboarder = () => useCurrentRole()?.kind === 'onboarder';
export const useIsUserValidator = () => useCurrentRole()?.kind === 'validator';

export const useIsTrueUserAdmin = () => {
  const isCurrentUserAdmin = useIsCurrentUserAdmin();
  const isAdminImpersonating = useIsAdminImpersonating();
  return isCurrentUserAdmin || isAdminImpersonating;
};
